import {Grid} from "@mui/material";
import {KeyVaultSelect, KeyVaultSelectOpt} from "../key-vault-select/KeyVaultSelect";
import React, {useMemo} from "react";
import {KeyVault} from "../../api/Model";
import {mapSetState, SetState} from "../../util/FormHandlers";
import {FieldErrors} from "../form-validation/useFormValidation";

export function KeyVaultFilter<Filter extends { keyVault: KeyVault }>({filter, setFilter, fieldErrors}: {
    filter: Filter,
    setFilter: SetState<Filter>,
    fieldErrors?: FieldErrors<'key-vault'>,
}) {
    const setKeyVault = useMemo(
        () => mapSetState(setFilter, 'keyVault'),
        [setFilter]
    );

    return (
        <Grid size={{xs: 12, sm: 6, md: 4, lg: 3, xl: 2}}>
            <KeyVaultSelect
                label="Key Vault"
                keyVault={filter.keyVault}
                setKeyVault={setKeyVault}
                {...fieldErrors}
            />
        </Grid>
    );
}

export function KeyVaultFilterOpt<Filter extends { keyVault: KeyVault | null }>({filter, setFilter}: {
    filter: Filter,
    setFilter: SetState<Filter>,
}) {
    const setKeyVault = useMemo(
        () => mapSetState(setFilter, 'keyVault'),
        [setFilter],
    );

    return (
        <Grid size={{lg: 2.5, md: 3, xs: 12}}>
            <KeyVaultSelectOpt
                label="Vault"
                keyVault={filter.keyVault}
                setKeyVault={setKeyVault}
                emptyLabel="All Vaults"
            />
        </Grid>
    );
}